export const formatCurrency = (value: number, cents = true): string => {
  return cents ? (value / 100).toFixed(2) : (value / 100).toFixed(0)
}
